<template>
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <img class="mx-auto h-20 w-20" src="/img/logo.png"
                alt="Your Company" />
            <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Ingresa al sitio!</h2>
        </div>
        <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form id="loginForm" class="space-y-6" @submit.prevent="submitLoginForm">
                <div>
                    <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Ingrese su Email</label>
                    <div class="mt-2">
                        <input id="email" name="email" type="email" autocomplete="email" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Ingrese su contraseña</label>
                    <div class="mt-2">
                        <input id="password" name="password" type="password" autocomplete="password" required=""
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>
                <div>
                    <button type="submit"
                        class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Ingresar</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    // Importar Axios
    import axios from 'axios';

    export default {
    mounted() {
        // Realizar la solicitud POST cuando el componente se monta
        axios.post('http://127.0.0.1:8000/api/login', {
            email: 'usuario@example.com',
            password: 'contraseña',
        })
        .then(response => {
            // Manejar la respuesta
            const token = response.data.token;
            document.cookie = `token=${token}; Secure; HttpOnly; SameSite=Strict`;
        })
        .catch(error => {
            // Manejar errores
            console.error('Error en la solicitud:', error);
        });
    }
    }
</script>

